import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.accountList.loading;
export const selectErrorMessage = (state: RootState) => state.accountList.error;
export const accountListDataResponse = (state: RootState) =>
  state.accountList.accountListResponse;
